import { Helmet } from "react-helmet-async";

const SITE_URL = "https://controle-technique-montreuil-sous-bois.fr";

// LocalBusiness schema for the main site
export const LocalBusinessSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Autosur Montreuil-sous-Bois",
    "alternateName": "AUTOSUR MOTOSUR Montreuil",
    "description": "Centre de contrôle technique agréé à Montreuil-sous-Bois. Voitures, motos, véhicules de collection, utilitaires.",
    "url": SITE_URL,
    "telephone": "+33149889240",
    "email": "autosur.montreuil@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133, Boulevard Aristide Briand",
      "addressLocality": "Montreuil-sous-Bois",
      "postalCode": "93100",
      "addressCountry": "FR",
      "addressRegion": "Île-de-France"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.87316,
      "longitude": 2.45353
    },
    "image": `${SITE_URL}/og-image.png`,
    "logo": {
      "@type": "ImageObject",
      "url": `${SITE_URL}/og-image.png`,
      "width": 1200,
      "height": 630
    },
    "priceRange": "€€",
    "currenciesAccepted": "EUR",
    "paymentAccepted": "Cash, Credit Card",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:30",
        "closes": "18:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "13:00"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "343",
      "reviewCount": "343"
    },
    "review": [
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Hakim Ouarezki" },
        "datePublished": "2026-01-20",
        "reviewBody": "Je recommande vivement ce centre de contrôle technique, Mr Yacine et son équipe sont vraiment adorables. Ils sont à l'écoute et font tout leur possible pour nous trouver un créneau même si des fois ils sont chargés ! Un grand bon jour à toute l'équipe et bon courage.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Traore Makan" },
        "datePublished": "2026-01-11",
        "reviewBody": "Le meilleur contrôle technique de Montreuil, professionnel ponctuel il est au top. N'hésitez pas à passer chez lui, vous n'allez pas le regretter.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Sarah Lhcn" },
        "datePublished": "2025-12-15",
        "reviewBody": "Équipe super sympathique et professionnelle. Merci pour tout, on recommande vivement !",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Oulfa S." },
        "datePublished": "2025-11-11",
        "reviewBody": "Equipe tres professionnelle. Tres bon accueil. Merci à vous. Je recommande. Bonne continuation.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Faustin Keba Gingu" },
        "datePublished": "2025-11-11",
        "reviewBody": "Technicien sympathique et très professionnel. Contrôle technique minutieux et sérieux. Respect de l'heure du rendez-vous.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Franck Jardin" },
        "datePublished": "2026-01-28",
        "reviewBody": "Accueil exemplaire et excellent travail, je recommande. Rdv dans deux ans !",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Vincent Farau" },
        "datePublished": "2026-01-14",
        "reviewBody": "Un grand merci à Enzo et Yacine pour leur professionnalisme. Je recommande vivement.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Zinedine Ayaz" },
        "datePublished": "2025-05-11",
        "reviewBody": "Je recommande vivement ce centre de contrôle technique ! Accueil chaleureux, ponctualité irréprochable et service très professionnel. Le personnel est à l'écoute, prend le temps d'expliquer clairement les points vérifiés, et donne de bons conseils.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      },
      {
        "@type": "Review",
        "author": { "@type": "Person", "name": "Alexiane Liaud" },
        "datePublished": "2025-04-11",
        "reviewBody": "2ème fois que je fais faire mon contrôle technique chez eux. Prise de rdv rapide par téléphone, avec disponibilité dès le lendemain. L'équipe est accueillante et vraiment gentille, professionnelle et pédagogue.",
        "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" }
      }
    ],
    "sameAs": [
      "https://controle-technique.autosur.fr/550-autosur-montreuil-sous-bois",
      "https://maps.app.goo.gl/QMbfid7TsPVr8ZB76"
    ],
    "areaServed": [
      { "@type": "City", "name": "Montreuil-sous-Bois" },
      { "@type": "City", "name": "Bagnolet" },
      { "@type": "City", "name": "Romainville" },
      { "@type": "City", "name": "Les Lilas" },
      { "@type": "City", "name": "Noisy-le-Sec" },
      { "@type": "City", "name": "Fontenay-sous-Bois" },
      { "@type": "City", "name": "Vincennes" },
      { "@type": "City", "name": "Saint-Mandé" },
      { "@type": "City", "name": "Rosny-sous-Bois" },
      { "@type": "City", "name": "Bondy" }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Contrôles techniques",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Contrôle technique voiture"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Contrôle technique moto"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Contrôle technique utilitaire"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Contrôle technique véhicule de collection"
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// WebSite schema for sitelinks
export const WebSiteSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Autosur Montreuil-sous-Bois",
    "alternateName": "Contrôle Technique Montreuil",
    "url": SITE_URL
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// FAQ schema
interface FAQItem {
  question: string;
  answer: string;
}

export const FAQSchema = ({ items }: { items: FAQItem[] }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// Article schema (BlogPosting for SEO)
interface ArticleSchemaProps {
  title: string;
  description: string;
  slug: string;
  publishedAt: string;
  modifiedAt?: string;
  author: string;
  image?: string;
  faq?: { question: string; answer: string }[];
}

export const ArticleSchema = ({ title, description, slug, publishedAt, modifiedAt, author, image, faq }: ArticleSchemaProps) => {
  const articleImage = image || `${SITE_URL}/og-image.png`;
  const schemas: object[] = [
    {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "headline": title,
      "description": description,
      "url": `${SITE_URL}/blog/${slug}`,
      "image": [articleImage],
      "author": {
        "@type": "Organization",
        "name": "AUTOSUR Montreuil",
        "url": SITE_URL,
        "logo": {
          "@type": "ImageObject",
          "url": `${SITE_URL}/favicon-96x96.png`
        }
      },
      "publisher": {
        "@type": "Organization",
        "name": "AUTOSUR Montreuil",
        "logo": {
          "@type": "ImageObject",
          "url": `${SITE_URL}/og-image.png`,
          "width": 1200,
          "height": 630
        }
      },
      "datePublished": publishedAt,
      "dateModified": modifiedAt || publishedAt,
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": `${SITE_URL}/blog/${slug}`
      },
      "wordCount": 2000,
      "inLanguage": "fr-FR"
    }
  ];

  // Add FAQPage schema if FAQ data provided
  if (faq && faq.length > 0) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faq.map(item => ({
        "@type": "Question",
        "name": item.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": item.answer
        }
      }))
    });
  }

  return (
    <Helmet>
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

// City service area schema (for city landing pages)
export const CityServiceAreaSchema = ({ cityName }: { cityName: string }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Autosur Montreuil-sous-Bois",
    "url": SITE_URL,
    "telephone": "+33149889240",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133, Boulevard Aristide Briand",
      "addressLocality": "Montreuil-sous-Bois",
      "postalCode": "93100",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 48.87316,
      "longitude": 2.45353
    },
    "serviceArea": {
      "@type": "City",
      "name": cityName
    },
    "areaServed": [
      { "@type": "City", "name": cityName },
      { "@type": "City", "name": "Montreuil-sous-Bois" }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "bestRating": "5",
      "ratingCount": "343",
      "reviewCount": "343"
    },
    "priceRange": "€€",
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:30",
        "closes": "18:30"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "13:00"
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// BreadcrumbList schema
interface BreadcrumbItem {
  name: string;
  href: string;
}

export const BreadcrumbSchema = ({ items }: { items: BreadcrumbItem[] }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${SITE_URL}${item.href}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

// City Reviews schema (for city landing pages testimonials)
interface CityReview {
  author: string;
  city: string;
  text: string;
  rating: number;
  date: string;
}

export const CityReviewsSchema = ({ reviews }: { reviews: CityReview[] }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Autosur Montreuil-sous-Bois",
    "url": SITE_URL,
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "343",
      "reviewCount": "343"
    },
    "review": reviews.map(review => ({
      "@type": "Review",
      "author": { "@type": "Person", "name": review.author },
      "datePublished": review.date,
      "reviewBody": review.text,
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": String(review.rating),
        "bestRating": "5",
        "worstRating": "1"
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};
